import { ReactElement } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import styled from 'styled-components';

import { LabelS } from '@sorare/core/src/atoms/typography';

interface Props {
  title: MessageDescriptor;
  description?: MessageDescriptor | null;
  content?: ReactElement;
}

const Root = styled.div`
  text-align: left;
  color: var(--c-white);
`;
export const TooltipContent = (props: Props) => {
  const { title, description, content } = props;

  return (
    <Root>
      <LabelS bold>
        <FormattedMessage {...title} />
      </LabelS>
      {description && (
        <LabelS color="var(--c-nd-600)">
          <FormattedMessage {...description} />
        </LabelS>
      )}
      {content}
    </Root>
  );
};
